/**
 * Copyright © 2026 Adnuntius AS.
 */

export default [
  {
    type: 'PoliticalEntity',
    labelOverride: 'Controlling Entity',
    resolve: function(data) {
      if (data.type !== 'SPONSOR') {
        return null;
      }
      const p = data._politicalEntityCrumbParent;
      if (!p || !p.id) {
        return null;
      }
      return {id: p.id, name: p.name || 'Controller'};
    }
  }
];
